import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import InstallPage from '../pages/install/page';
import Layout from '../components/feature/Layout';
import AuthGuard from '../components/feature/AuthGuard';
import AdminGuard from '../components/feature/AdminGuard';
import Home from '../pages/home/page';
import Albums from '../pages/albums/page';
import AlbumCreate from '../pages/album-create/page';
import AlbumEdit from '../pages/album-edit/page';
import AlbumDetail from '../pages/album-detail/page';
import Upload from '../pages/upload/page';
import PhotoDetailPage from '../pages/PhotoDetailPage';
import Profile from '../pages/profile/page';
import AccountSettings from '../pages/profile/account/page';
import Login from '../pages/login/page';
import Signup from '../pages/signup/page';
import ForbiddenPage from '../pages/forbidden/page';
import AdminDashboardPage from '../pages/admin/page';
import AdminPendingPage from '../pages/admin/pending/page';
import AdminUsersPage from '../pages/admin/users/page';
import AdminHomeSettingsPage from '../pages/admin/home-settings/page';
import AdminFamilyMembersPage from '../pages/admin/family-members/page';
import AdminFamiliesPage from '../pages/admin/families/page';
import SearchPage from '../pages/search/page';
import SlideshowPage from '../pages/slideshow/page';
import NotificationsPage from '../pages/notifications/page';
import SettingsPage from '../pages/settings/page';
import NotificationSettingsPage from '../pages/settings/notifications/page';
import MemoryNotificationPage from '../pages/memories/page';

const routes: RouteObject[] = [
  { path: '/install', element: <InstallPage /> },
  { path: '/login', element: <Login /> },
  { path: '/signup', element: <Signup /> },
  {
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      { path: '/', element: <Home /> },
      { path: '/albums', element: <Albums /> },
      { path: '/album/create', element: <AlbumCreate /> },
      { path: '/album/:id', element: <AlbumDetail /> },
      { path: '/album/:id/edit', element: <AlbumEdit /> },
      { path: '/upload', element: <Upload /> },
      { path: '/search', element: <SearchPage /> },
      { path: '/profile', element: <Profile /> },
      { path: '/notifications', element: <NotificationsPage /> },
      { path: '/settings', element: <SettingsPage /> },
      { path: '/settings/notifications', element: <NotificationSettingsPage /> },
      { path: '/memories/:notificationId', element: <MemoryNotificationPage /> },
      { path: '/profile/account', element: <AccountSettings /> },
      { path: '/albums/:albumId/photos/:photoId', element: <PhotoDetailPage /> },
      { path: '/forbidden', element: <ForbiddenPage /> },
      {
        path: '/admin',
        element: <AdminGuard><AdminDashboardPage /></AdminGuard>,
      },
      {
        path: '/admin/pending',
        element: <AdminGuard><AdminPendingPage /></AdminGuard>,
      },
      {
        path: '/admin/users',
        element: <AdminGuard><AdminUsersPage /></AdminGuard>,
      },
      {
        path: '/admin/home-settings',
        element: <AdminGuard><AdminHomeSettingsPage /></AdminGuard>,
      },
      {
        path: '/admin/family-members',
        element: <AdminGuard><AdminFamilyMembersPage /></AdminGuard>,
      },
      {
        path: '/admin/families',
        element: <AdminGuard><AdminFamiliesPage /></AdminGuard>,
      },
    ],
  },
  {
    path: '/slideshow',
    element: <AuthGuard><SlideshowPage /></AuthGuard>,
  },
  { path: '*', element: <NotFound /> },
];

export default routes;
